import { endpoint } from '@library/endpoint'

import { deliveries } from 'config/routes'
import { fetch } from 'utils/fetch'

export function fetchDeliveryConsignment(accessToken: string, orderId: string) {
  const reqData = {
    'filters[order_id]': orderId,
  }

  const url = `${endpoint('deliveries')}${deliveries.consignments}`

  return fetch(accessToken, url, reqData, 'GET')
}
